import React, { useState } from 'react';
import { createPortal } from 'react-dom';

import EmergencyMessage from '..';

export interface EmergencyMessageProps {
  message: string;
  onClick?: () => void;
}

interface EmergencyMessageCreateContext {
  set: (content: EmergencyMessageProps) => void;
  reset: () => void;
  hide: () => void;
  show: () => void;
  isVisible: () => boolean;
}

interface EmergencyMessageCreateProviderProps {
  children?: React.ReactNode;
}

const EmergencyMessageContext = React.createContext({} as EmergencyMessageCreateContext);

export const EmergencyMessageProvider = ({ children }: EmergencyMessageCreateProviderProps) => {
  const [visible, setVisible] = useState(true);
  const [current, setCurrent] = useState<EmergencyMessageProps | null>(null);

  const set = (content: EmergencyMessageProps) => {
    setCurrent(content);
    setVisible(true);
  };

  const hide = () => setVisible(false);
  const show = () => setVisible(true);

  const reset = () => {
    setCurrent(null);
    setVisible(true);
  };

  const isVisible = () => visible && current !== null;

  return (
    <EmergencyMessageContext.Provider value={{ set, reset, hide, show, isVisible }}>
      {createPortal(
        isVisible() ? <EmergencyMessage message={current?.message} onClick={current?.onClick} /> : null,
        document.body,
      )}
      {children}
    </EmergencyMessageContext.Provider>
  );
};

export default EmergencyMessageContext;
